export const textObj = {
  activity:{
    //活动开头文案
    words:[
      "值此八一建军节之际，我们深情回望，自1927年8月1日南昌城头的第一声枪响起，人民军队便在风雨中茁壮成长。从战火纷飞的革命岁月，到和平建设的新时代，再到深化改革的征程上，人民军队始终是国家安全的坚强柱石，是人民幸福生活的守护者。为庆祝中国人民解放军建军97周年，“书香中国”全民阅读平台特举办线上知识竞赛，旨在通过答题活动，增强公众国防意识，弘扬爱国主义精神，共同铭记历史，传承红色基因。" 
    ],
    //活动二维码
    codeImg:require("../img/common/code.png"),
    //活动跳转地址
    linkUrl:"https://www.wjx.top/vm/egdYkil.aspx",
    prizes:[
      {name:'筋膜枪',level:"一等奖",img:require("../img/common/prize1.png"),num:'1名'},
      {name:'充电宝',level:"二等奖",img:require("../img/common/prize2.png"),num:'3名'},
      {name:'香薰',level:"三等奖",img:require("../img/common/prize3.png"),num:'6名'}
    ],
    rules:[
      {title:"一、活动对象",value:"“书香中国”平台全体用户"},
      {title:"二、活动时间",value:"2024年8月1日至2024年8月30日"},
      {title:"三、活动规则",
      value:
      "<p class=\"title2\">1.知识竞赛活动的题目由题库中随机抽取，总共10道题，答对一题得10分，答错不扣分，满分100分，答完所有题后系统会自动统计出最后得分。</p>"
      +"<p class=\"title2\">2.每个参赛者在活动期间可以多次答题，以其中最高分为最后答题得分。活动首先根据用户得分进行排名，如果有相同得分的用户，则再比较用户答题所用时间，答题所用时间越短排名越靠前；若得分和答题所用时间皆相同，则越早提交问卷的用户，排名越靠前。活动禁止恶意刷题，答题时间过短（例如答题时间低于10秒）将取消其活动资格。</p>"
      +"<p class=\"title2\">3.获奖读者名单及领奖方式将在“中文在线微书房”微信公众号平台发布。</p>"
    }
    
    ]
  }
}
